import React from "react";

export function HomeIcon({
  size = 15,
  color = "currentColor",
  style,
  ...props
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 15 15"
      fill="none"
      style={{ color, ...style }}
      {...props}
    >
      <path
        d="M5.33333 11.2516H9.33333V9.91829H5.33333V11.2516Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.33344 0C6.69566 0 6.13908 0.223807 5.56506 0.579025C5.01433 0.919835 4.38899 1.42012 3.61831 2.03669L2.13685 3.22179C1.26527 3.91827 0.659165 4.40262 0.329093 5.08937C-0.00097851 5.77613 -0.000556185 6.55199 5.10675e-05 7.66766L0.000103679 8.63378C8.53203e-05 9.84941 7.05421e-05 10.8293 0.10368 11.5999C0.21125 12.4 0.441378 13.0737 0.976415 13.6087C1.51145 14.1437 2.18512 14.3739 2.98521 14.4814C3.75586 14.585 4.7357 14.585 5.95135 14.585H8.71553C9.93117 14.585 10.911 14.585 11.6817 14.4814C12.4818 14.3739 13.1554 14.1437 13.6905 13.6087C14.2255 13.0737 14.4556 12.4 14.5632 11.5999C14.6668 10.8292 14.6668 9.8494 14.6668 8.63376L14.6668 7.66766C14.6674 6.55198 14.6679 5.77613 14.3378 5.08937C14.0077 4.40261 13.4016 3.91827 12.53 3.22178L11.0486 2.03671C10.2779 1.42014 9.65255 0.919836 9.10181 0.579025C8.52779 0.223807 7.97121 0 7.33344 0ZM4.41819 3.10428C5.22984 2.45496 5.79265 2.00617 6.26669 1.71282C6.72529 1.42903 7.03579 1.33333 7.33344 1.33333C7.63108 1.33333 7.94159 1.42903 8.40019 1.71282C8.87422 2.00617 9.43703 2.45496 10.2487 3.10428L11.582 4.17094C12.6155 4.99775 12.9541 5.28834 13.136 5.66696C13.318 6.04557 13.3334 6.49146 13.3334 7.815V8.585C13.3334 9.86093 13.332 10.7508 13.2418 11.4222C13.1541 12.0745 12.9937 12.4199 12.7477 12.6659C12.5016 12.9119 12.1562 13.0723 11.504 13.16C10.8326 13.2503 9.9427 13.2517 8.66677 13.2517H6.0001C4.72418 13.2517 3.8343 13.2503 3.16288 13.16C2.51063 13.0723 2.16524 12.9119 1.91922 12.6659C1.67321 12.4199 1.51282 12.0745 1.42512 11.4222C1.33485 10.7508 1.33344 9.86093 1.33344 8.585V7.815C1.33344 6.49146 1.34886 6.04557 1.53083 5.66696C1.7128 5.28834 2.05135 4.99775 3.08486 4.17094L4.41819 3.10428Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function HomeActiveIcon({
  size = 15,
  color = "currentColor",
  style,
  ...props
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ color, ...style }}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.56506 0.579025C6.13908 0.223807 6.69566 0 7.33344 0C7.97121 0 8.52779 0.223807 9.10181 0.579025C9.65255 0.919838 10.2779 1.42013 11.0486 2.03671L11.0816 2.06312L12.4149 3.12979L12.53 3.22178C13.4016 3.91827 14.0077 4.40261 14.3378 5.08937C14.6679 5.77613 14.6674 6.55198 14.6668 7.66766L14.6668 7.815V8.585V8.63376C14.6668 9.8494 14.6668 10.8292 14.5632 11.5999C14.4556 12.4 14.2255 13.0737 13.6905 13.6087C13.1554 14.1437 12.4818 14.3739 11.6817 14.4814C10.911 14.585 9.93117 14.585 8.71553 14.585H8.66677H6.0001H5.95135C4.7357 14.585 3.75586 14.585 2.98521 14.4814C2.18512 14.3739 1.51145 14.1437 0.976415 13.6087C0.441378 13.0737 0.21125 12.4 0.10368 11.5999C7.05421e-05 10.8293 8.53203e-05 9.84941 0.000103679 8.63378L0.000104155 8.585V7.815L5.10675e-05 7.66766C-0.000556185 6.55199 -0.00097851 5.77613 0.329093 5.08937C0.659165 4.40262 1.26527 3.91827 2.13685 3.22179L2.25193 3.12979L3.58527 2.06312L3.6183 2.03669C4.38898 1.42013 5.01433 0.919836 5.56506 0.579025ZM5.33341 11.2517H9.33341V9.91833H5.33341V11.2517Z"
        fill="currentColor"
      />
    </svg>
  );
}
